<div class="container-fluid webhook-page">
  <app-content-tab-list activeTab="2" type="twitter" category="Twitter"></app-content-tab-list>

  <div class="webhook-header mt-4">
    <div class="home-details">
      <h5 class="home-title">Webhook Requests ({{ total | number: "1.0-0" }})</h5>
      <p class="home-subtitle mb-0">Every payload received from twitterapi.io</p>
    </div>
    <button class="btn btn-primary btn-dashboard" (click)="loadRequests()" [disabled]="loading">
      <i class="las la-sync"></i>{{ loading ? "Refreshing..." : "Refresh" }}
    </button>
  </div>

  <div class="requests-card">
    <div class="table-responsive requests-table">
      <table class="table mb-0">
        <thead><tr><th>Received</th><th>Event / rule</th><th>Status</th><th>Tweets</th><th>Saved</th><th class="action-column">Actions</th></tr></thead>
        <tbody>
          @if (loading) {
            <tr><td colspan="6" class="text-center py-5">Loading webhook requests...</td></tr>
          }
          @for (request of requests | paginate: { itemsPerPage: perPage, currentPage: page, totalItems: total, id: 'twitter-webhook-requests' }; track request._id) {
            <tr>
              <td>{{ request.createdAt | date: "medium" }}</td>
              <td>
                <strong>{{ request.eventType || "Unknown" }}</strong>
                <small>
                  {{ request.goldenHandle?.name || request.ruleTag || request.ruleId || "No rule" }}
                  @if (request.goldenHandle) {
                    <button class="handle-view" type="button" title="View Golden Handle" (click)="openGoldenHandle(request.goldenHandle)"><i class="las la-eye"></i></button>
                  }
                </small>
              </td>
              <td><span class="request-status" [class.failed]="request.status === 'failed'">{{ request.status }}</span></td>
              <td>{{ request.receivedCount || 0 | number: "1.0-0" }}</td>
              <td>{{ request.savedCount || 0 | number: "1.0-0" }}</td>
              <td class="action-column">
                <div class="dropdown">
                  <button type="button" class="btn header-item waves-effect btn-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="text-primary py-2 text-nowrap">View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></span>
                  </button>
                  <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                    <button type="button" class="dropdown-item text-primary border-bottom py-2 text-nowrap" (click)="openPayload(request)">
                      <i class="las la-eye mb-1 la-lg align-middle mr-0"></i> View payload
                    </button>
                    <button type="button" class="dropdown-item text-danger py-2 text-nowrap" (click)="deleteRequest(request)">
                      <i class="las la-trash-alt mb-1 la-lg align-middle mr-0"></i> Delete
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          }
          @if (!loading && !requests.length) {
            <tr><td colspan="6" class="text-center py-5">No webhook requests received yet.</td></tr>
          }
        </tbody>
      </table>
    </div>
    @if (total > perPage) {
      <div class="request-pagination"><pagination-controls id="twitter-webhook-requests" (pageChange)="pageChange($event)"></pagination-controls></div>
    }
  </div>

  @if (selectedRequest) {
    <div class="payload-modal-backdrop" (click)="closePayload()">
      <div class="payload-modal" role="dialog" aria-modal="true" aria-labelledby="payload-modal-title" (click)="$event.stopPropagation()">
        <div class="payload-modal-header">
          <div>
            <h5 id="payload-modal-title">Webhook Payload</h5>
            <p>{{ selectedRequest.eventType || "Unknown event" }} · {{ selectedRequest.createdAt | date: "medium" }}</p>
          </div>
          <button type="button" class="payload-modal-close" aria-label="Close" (click)="closePayload()"><i class="las la-times"></i></button>
        </div>
        <div class="payload-stats">
          <div><span>Posts received</span><strong>{{ selectedRequest.receivedCount || 0 | number: "1.0-0" }}</strong></div>
          <div class="duplicate"><span>Duplicated</span><strong>{{ selectedDuplicateCount | number: "1.0-0" }}</strong></div>
          <div class="added"><span>Added</span><strong>{{ selectedRequest.savedCount || 0 | number: "1.0-0" }}</strong></div>
        </div>
        <div class="payload-tabs" role="tablist">
          <button type="button" [class.active]="payloadTab === 'posts'" (click)="payloadTab = 'posts'">Posts ({{ selectedTweets.length | number: "1.0-0" }})</button>
          <button type="button" [class.active]="payloadTab === 'raw'" (click)="payloadTab = 'raw'">Raw payload</button>
        </div>
        <div class="payload-modal-body">
          @if (payloadTab === "posts") {
            <div class="tweet-list">
              @for (tweet of selectedTweets; track tweet.id) {
                <article class="tweet-card">
                  <img class="tweet-avatar" [src]="tweet.author?.profilePicture" [alt]="tweet.author?.name || tweet.author?.userName" />
                  <div class="tweet-content">
                    <div class="tweet-author">
                      <strong>{{ tweet.author?.name || tweet.author?.userName || "Unknown" }}</strong>
                      @if (tweet.author?.isBlueVerified || tweet.author?.isVerified) { <i class="las la-check-circle" aria-label="Verified"></i> }
                      <span>&#64;{{ tweet.author?.userName || "unknown" }} · {{ tweet.createdAt | date: "medium" }}</span>
                    </div>
                    <p>{{ tweet.text }}</p>
                    @if (tweetImage(tweet)) {
                      <img class="tweet-media" [src]="tweetImage(tweet)" alt="Post media" loading="lazy" />
                    }
                    <div class="tweet-metrics">
                      <span><i class="las la-comment"></i>{{ compactCount(tweet.replyCount) }}</span>
                      <span><i class="las la-retweet"></i>{{ compactCount(tweet.retweetCount) }}</span>
                      <span><i class="lar la-heart"></i>{{ compactCount(tweet.likeCount) }}</span>
                      <span><i class="las la-chart-bar"></i>{{ compactCount(tweet.viewCount) }}</span>
                      <a [href]="tweet.url || tweet.twitterUrl" target="_blank" rel="noopener">View on X <i class="las la-external-link-alt"></i></a>
                    </div>
                  </div>
                </article>
              }
              @if (!selectedTweets.length) { <div class="empty-posts">This payload contains no tweets.</div> }
            </div>
          } @else {
            <pre>{{ selectedRequest.payload | json }}</pre>
          }
        </div>
        <div class="payload-modal-footer"><button type="button" class="btn btn-primary btn-dashboard" (click)="closePayload()">Close</button></div>
      </div>
  </div>
}

@if (selectedGoldenHandle) {
  <app-golden-handle-modal [goldenHandle]="selectedGoldenHandle" (closed)="closeGoldenHandle()"></app-golden-handle-modal>
}
</div>
